export const ERROR_MESSAGES = {
  ROOT_NOT_FOUND: '앱을 마운트할 루트 엘리먼트를 찾을 수 없습니다.',
  UNKNOWN_ERROR: '알 수 없는 에러가 발생했습니다.',
  APP_LOAD_FAILED: '앱 초기화에 실패했습니다.',
  TRY_AGAIN: '잠시 후 다시 시도해주세요.'
}
